var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNfTmarketfee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#232B34;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#D6D6D6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,65H10C4.48,65,0,60.52,0,55V10C0,4.48,4.48,0,10,0h45c5.52,0,10,4.48,10,10v45C65,60.52,60.52,65,55,65z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 25.06,
    className: "st1",
    width: 24.61,
    height: 19.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8,45.47H20.2l-0.73-0.73V25.06l0.73-0.73H44.8l0.73,0.73v19.68L44.8,45.47z M20.93,44.01h23.14V25.79H20.93V44.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.49,31.32L21.49,31.32c-1.52,0-2.75-1.23-2.75-2.75v-8.31h5.51v8.31C24.24,30.09,23.01,31.32,21.49,31.32z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.49,32.06c-1.92,0-3.49-1.56-3.49-3.49v-8.31l0.73-0.73h5.51l0.73,0.73v8.31C24.97,30.49,23.41,32.06,21.49,32.06z  M19.47,20.99v7.58c0,1.11,0.91,2.02,2.02,2.02c1.11,0,2.02-0.91,2.02-2.02v-7.58H19.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.99,31.32L26.99,31.32c-1.52,0-2.75-1.23-2.75-2.75v-8.31h5.51v8.31C29.75,30.09,28.51,31.32,26.99,31.32z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.99,32.06c-1.92,0-3.49-1.56-3.49-3.49v-8.31l0.73-0.73h5.51l0.73,0.73v8.31C30.48,30.49,28.92,32.06,26.99,32.06z  M24.97,20.99v7.58c0,1.11,0.91,2.02,2.02,2.02c1.11,0,2.02-0.91,2.02-2.02v-7.58H24.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,31.32L32.5,31.32c-1.52,0-2.75-1.23-2.75-2.75v-8.31h5.51v8.31C35.25,30.09,34.02,31.32,32.5,31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,32.06c-1.92,0-3.49-1.56-3.49-3.49v-8.31l0.73-0.73h5.51l0.73,0.73v8.31C35.99,30.49,34.42,32.06,32.5,32.06z  M30.48,20.99v7.58c0,1.11,0.91,2.02,2.02,2.02c1.11,0,2.02-0.91,2.02-2.02v-7.58H30.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.01,31.32L38.01,31.32c-1.52,0-2.75-1.23-2.75-2.75v-8.31h5.51v8.31C40.76,30.09,39.53,31.32,38.01,31.32z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.01,32.06c-1.92,0-3.49-1.56-3.49-3.49v-8.31l0.73-0.73h5.51l0.73,0.73v8.31C41.49,30.49,39.93,32.06,38.01,32.06z  M35.99,20.99v7.58c0,1.11,0.91,2.02,2.02,2.02c1.11,0,2.02-0.91,2.02-2.02v-7.58H35.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.51,31.32L43.51,31.32c-1.52,0-2.75-1.23-2.75-2.75v-8.31h5.51v8.31C46.27,30.09,45.03,31.32,43.51,31.32z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51,32.06c-1.92,0-3.49-1.56-3.49-3.49v-8.31l0.73-0.73h5.51L47,20.26v8.31C47,30.49,45.44,32.06,43.51,32.06z  M41.49,20.99v7.58c0,1.11,0.91,2.02,2.02,2.02s2.02-0.91,2.02-2.02v-7.58H41.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.03,
    y: 35.37,
    className: "st2",
    width: 5.51,
    height: 9.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.53,45.47h-5.51l-0.73-0.73v-9.37l0.73-0.73h5.51l0.73,0.73v9.37L39.53,45.47z M34.76,44.01h4.04V36.1h-4.04V44.01z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNfTmarketfee);
export default __webpack_public_path__ + "static/media/icon_NFTmarketfee.e42e877bfefb7531336ce59d119614b7.svg";
export { ForwardRef as ReactComponent };